import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "-mt-10 -mb-4" }

import { // languages
		useI18n
	} from 'vue-i18n'

	import { // store
		localesStore
	} from '@/store/locales'

	import { // vue
		computed
	} from 'vue'

	
	const __default__ = { name: 'JobBorrowedItems' } // name the component

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
		job: {
			type: Object,
			default: () => {return {}}
		},
		loading: {
			type: Boolean,
			default: false
		}
	},
  setup(__props) {

	const props = __props

	const store = localesStore()

	const {t} = useI18n()

	const groupedData = computed(() => {
		let headings = []

		if(props?.job?.portalData?.portal_borrowed_bride_groom?.length) {
			headings.push(
				{subheading: 'Bride & Groom'},
				...props.job.portalData.portal_borrowed_bride_groom
			)
		}

		if(props?.job?.portalData?.portal_borrowed_employee?.length) {
			headings.push(	
				{subheading: 'Employees'},
				...props.job.portalData.portal_borrowed_employee
			)
		}

		if(props?.job?.portalData?.portal_borrowed_planner?.length) {
			headings.push(
				{subheading: 'Planners'},
				...props.job.portalData.portal_borrowed_planner
			)
		}

		return headings
	})



return (_ctx: any,_cache: any) => {
  const _component_tw_table_column = _resolveComponent("tw-table-column")!
  const _component_CheckIconMini = _resolveComponent("CheckIconMini")!
  const _component_MinusIconMini = _resolveComponent("MinusIconMini")!
  const _component_tw_table = _resolveComponent("tw-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_tw_table, {
      placeholder: _unref(t)('placeholders.noItems'),
      data: groupedData.value,
      loading: __props.loading
    }, {
      default: _withCtx(() => [
        _createVNode(_component_tw_table_column, {
          header: _unref(store).getLabel('159')
        }, {
          default: _withCtx(({row}) => [
            _createTextVNode(_toDisplayString(row['JOBS::name_bride_display'] ||
						row['JOBS::name_groom_display'] ||
						row['job__borrowed__CONTACTS__contactID_employee::name_display'] ||
						row['job__borrowed__CONTACTS__contactID_planner::name_display']), 1)
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_tw_table_column, {
          header: _unref(store).getLabel('190')
        }, {
          default: _withCtx(({row}) => [
            _createTextVNode(_toDisplayString(row['job__BORROWED__jobID_isBorrowedBrideGroom::borrowed_description_display'] ||
						row['job__BORROWED__jobID_isBorrowedEmployee::borrowed_description_display'] ||
						row['job__BORROWED__jobID_isBorrowedPlanner::borrowed_description_display']), 1)
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_tw_table_column, {
          header: _unref(store).getLabel('157')
        }, {
          default: _withCtx(({row}) => [
            (row['job__BORROWED__jobID_isBorrowedBrideGroom::cd'] ||
							row['job__BORROWED__jobID_isBorrowedEmployee::cd'] ||
							row['job__BORROWED__jobID_isBorrowedPlanner::cd'])
              ? (_openBlock(), _createBlock(_component_CheckIconMini, {
                  key: 0,
                  class: "h-5 w-5 text-black"
                }))
              : (_openBlock(), _createBlock(_component_MinusIconMini, {
                  key: 1,
                  class: "h-5 w-5 text-gray-300"
                }))
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_tw_table_column, {
          header: _unref(store).getLabel('161')
        }, {
          default: _withCtx(({row}) => [
            _createTextVNode(_toDisplayString(row['job__borrowed__CONTACTS__contactID_receivedBrideGroom::name_display'] ||
						row['job__borrowed__CONTACTS__contactID_receivedEmployee::name_display'] ||
						row['job__borrowed__CONTACTS__contactID_receivedPlanner::name_display']), 1)
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_tw_table_column, {
          header: _unref(store).getLabel('163')
        }, {
          default: _withCtx(({row}) => [
            _createTextVNode(_toDisplayString(row['job__BORROWED__jobID_isBorrowedBrideGroom::borrowed_date_received'] || 
						row['job__BORROWED__jobID_isBorrowedEmployee::borrowed_date_received'] ||
						row['job__BORROWED__jobID_isBorrowedPlanner::borrowed_date_received']), 1)
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_tw_table_column, {
          header: _unref(store).getLabel('162')
        }, {
          default: _withCtx(({row}) => [
            _createTextVNode(_toDisplayString(row['job__BORROWED__jobID_isBorrowedBrideGroom::borrowed_name_display'] ||
						row['job__BORROWED__jobID_isBorrowedEmployee::borrowed_name_display'] ||
						row['job__BORROWED__jobID_isBorrowedPlanner::borrowed_name_display']), 1)
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_tw_table_column, {
          header: _unref(store).getLabel('164')
        }, {
          default: _withCtx(({row}) => [
            _createTextVNode(_toDisplayString(row['job__BORROWED__jobID_isBorrowedBrideGroom::borrowed_date_returned'] ||
						row['job__BORROWED__jobID_isBorrowedEmployee::borrowed_date_returned'] ||
						row['job__BORROWED__jobID_isBorrowedPlanner::borrowed_date_returned']), 1)
          ]),
          _: 1
        }, 8, ["header"])
      ]),
      _: 1
    }, 8, ["placeholder", "data", "loading"])
  ]))
}
}

})